import moment from 'moment-timezone';

export const APP_TIMEZONE = 'America/Sao_Paulo';
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// Agendamentos sem offset sao horarios civis de Brasilia. ISO com offset preserva o instante.
export function scheduledDate(value) {
    return moment.tz(value, APP_TIMEZONE);
}

// Carimbos da API sem offset sao UTC; datas sem hora nunca mudam de dia.
export function displayDate(value, scheduled = false) {
    if (scheduled || (typeof value === 'string' && DATE_ONLY.test(value))) {
        return scheduledDate(value);
    }
    return moment.utc(value).tz(APP_TIMEZONE);
}

export default moment;
